import { useState, useEffect } from 'react';

// Проверка Capacitor
const isCapacitorNative = (): boolean => {
  try {
    // @ts-ignore
    return window.Capacitor?.isNativePlatform?.() || false;
  } catch {
    return false;
  }
};

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 768 || isCapacitorNative();
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768 || isCapacitorNative());
    };

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

export const useIsCapacitor = (): boolean => {
  return isCapacitorNative();
};

export const useIsTouchDevice = (): boolean => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  return isTouch;
};

// Константы для мобильного UI
export const MOBILE_BREAKPOINT = 768;
export const MIN_TOUCH_TARGET = 44; // минимальный размер кнопки для тапа

// Хелпер для классов
export const mobileClass = (isMobile: boolean, mobileClass: string, desktopClass: string = ''): string => {
  return isMobile ? mobileClass : desktopClass;
};
